export default class ApiResource {
  constructor(api, prefix) {
    this.api = api
    this.prefix = prefix
    this.paramName = prefix
    this.baseUrl = `${api.base}/${prefix}`
    this.axios = api.axios
  }

  list(options) {
    return this.get(null, options)
  }

  read(id, options) {
    return this.get(id, options)
  }

  create(params, options) {
    return this.post(null, this.scopedParams(params), options)
  }

  get(path, options) {
    return this.api.get(this.fullPath(path), options).then(response => response.data)
  }

  post(path, data, options) {
    return this.api.post(this.fullPath(path), data, options).then(response => response.data)
  }

  put(path, data, options) {
    return this.api.put(this.fullPath(path), data, options).then(response => response.data)
  }

  fullPath(path) {
    return path === null ? this.prefix : `${this.prefix}/${path}`
  }

  scopedParams(params) {
    const scoped = {}
    scoped[this.paramName] = params
    return scoped
  }
}
